<script setup>
import { computed } from 'vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update']);

const selectedValues = computed(() =>
  Array.isArray(props.attribute.value) ? props.attribute.value : []
);

const isSelected = option => selectedValues.value.includes(option);

const toggleOption = option => {
  const updatedValues = isSelected(option)
    ? selectedValues.value.filter(value => value !== option)
    : [...selectedValues.value, option];
  emit('update', updatedValues);
};
</script>

<template>
  <div class="flex flex-col w-full gap-1">
    <span class="mb-0.5 text-heading-3 text-n-slate-12">
      {{ attribute.attributeDisplayName }}
    </span>
    <div class="flex flex-col gap-2">
      <label
        v-for="option in attribute.attributeValues"
        :key="option"
        class="flex items-center gap-2 cursor-pointer"
      >
        <Checkbox
          :model-value="isSelected(option)"
          @change="toggleOption(option)"
        />
        <span class="text-sm text-n-slate-11">{{ option }}</span>
      </label>
    </div>
  </div>
</template>
